import { Box, Stack, styled, Typography } from '@mui/material'

const MainAreaWrapper = styled(Stack)``

const MixerToolsContainer = styled(Stack)`
  padding: 8px 32px;
  justify-content: center;
  align-items: flex-end;
  border-bottom: 1px solid ${(props) => props.theme.palette.divider};
`

const MixerToolsButton = styled(Stack)`
  width: 40px;
  margin-right: 24px;
`

const CostText = styled(Typography)`
  font-weight: 800;
  font-size: 18px;
  color: black;
`

const BlendMixerItem = styled(Stack)`
  background-color: #fcfcfc;
  border-bottom: 1px solid ${({ theme }) => theme.palette.customGrey.one};
  height: 77px;
  justify-content: center;
  padding: 8px 20px;
  gap: 24px;
  flex-direction: row;
  align-items: center;
`

const BlendMixerItemSection = styled(Stack)<{ flex?: number }>`
  flex: ${({ flex }) => flex || 1};
`

const SliderContainer = styled(Stack)`
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

const SliderValue = styled(Typography)`
  font-size: 16px;
  color: ${({ theme }) => theme.palette.text.primary};
  font-weight: 700;
`

const BlendMixerIconContainer = styled(Stack)`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: #efefef;
  align-items: center;
  justify-content: center;
  flex-direction: row;
`

const StyledIconButton = styled(Stack)`
  height: 14px;
  cursor: pointer;
  :active {
    opacity: 0.8;
  }
`

const TogglePinButtonWrapper = styled(Stack)`
  height: 14px;
`

const TogglePinAllIconContainer = styled(Box)`
  height: 24px;
`

const BlendMixerActions = styled(Stack)`
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

const BlendMixerTotalCostArea = styled(Stack)`
  width: 100%;
  padding: 16px;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-top: auto;
`

const BlendMixerButton = {
  height: 32,
}

export {
  MainAreaWrapper,
  MixerToolsContainer,
  MixerToolsButton,
  CostText,
  BlendMixerItem,
  BlendMixerItemSection,
  SliderContainer,
  SliderValue,
  BlendMixerIconContainer,
  StyledIconButton,
  BlendMixerActions,
  BlendMixerButton,
  BlendMixerTotalCostArea,
  TogglePinButtonWrapper,
  TogglePinAllIconContainer,
}
